module.exports = "/_next/static/images/Oliver_developer-c98a9249fefc2f50910d19c780f26884.svg";